import validator from "validator";
import { Link } from "react-router-dom";
import Modal from "@mui/material/Modal";
import { IconButton } from "@mui/material";
import Select, { components } from "react-select";
import React, { useState, useEffect, useRef } from "react";
import Input from "react-phone-number-input/input";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { trackButtonClick } from '../../../utils/gtm';

import * as ROUTES from "../../../constants/routes";
import ModalWrapper from "../../common/Modal/ModalWrapper";
import { updateUser } from '../../../reducers/userReducer';
import { setLoginType } from "../../../reducers/loginReducer";
import { updatePartner } from "../../../reducers/partnerReducer.js";
import { updateCompany } from "../../../reducers/companyReducer";
import { getRequest, postRequest, showMessage } from "../../../config";
import { setModalHistory, toggleModal } from "../../../reducers/modalReducer";
import { fetchCategories, UPDATE_CATEGORIES, } from "../../../reducers/commonReducer";


const PlusIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 48 48"
            width="30px"
            height="30px"
        >
            <path
                fill="#fd6474"
                d="M44,24c0,11.045-8.955,20-20,20S4,35.045,4,24S12.955,4,24,4S44,12.955,44,24z"
            />
            <path fill="#fff" d="M21,14h6v20h-6V14z" />
            <path fill="#fff" d="M14,21h20v6H14V21z" />
        </svg>
    );
};

const IconUser = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>;
const IconMail = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" /><polyline points="22,6 12,12 2,6" /></svg>;
const IconLock = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2" /><path d="M7 11V7a5 5 0 0 1 10 0v4" /></svg>;
const IconEye = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" /><circle cx="12" cy="12" r="3" /></svg>;
const IconEyeOff = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24" /><line x1="1" y1="1" x2="23" y2="23" /></svg>;
const IconSearch = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" /></svg>;
const IconBuilding = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="2" width="16" height="20" rx="1" /><line x1="9" y1="7" x2="9" y2="7" /><line x1="15" y1="7" x2="15" y2="7" /><line x1="9" y1="12" x2="9" y2="12" /><line x1="15" y1="12" x2="15" y2="12" /><line x1="9" y1="17" x2="15" y2="17" /></svg>;
const IconMapPin = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" /></svg>;
const IconBriefcase = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2" ry="2" /><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16" /></svg>;
const IconPhone = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z" /></svg>;
const IconGlobe = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" /><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" /></svg>;
const IconTag = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41 11 3.83A2 2 0 0 0 9.59 3.2H4a1 1 0 0 0-1 1v5.59a2 2 0 0 0 .59 1.42l9.58 9.58a2 2 0 0 0 2.82 0l4.6-4.6a2 2 0 0 0 0-2.82z" /><circle cx="7.5" cy="7.5" r="1" fill="currentColor" stroke="none" /></svg>;
const IconUpload = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" /><polyline points="17 8 12 3 7 8" /><line x1="12" y1="3" x2="12" y2="15" /></svg>;
const IconX = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" /></svg>;
const IconArrowLeft = () => <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>;

const RegisterTwoMinuteTest = ({ registerationType, refs, isAnimationVisible, registerPage, }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const user = useSelector((state) => state.user);
    const modal = useSelector((state) => state.modal);
    const partner = useSelector((state) => state.partner);

    const { categories } = useSelector((state) => state.common);
    const { selectedCompany } = useSelector((state) => state.company);
    const advisorsCategories = categories.filter((cat) => cat?.for === "advisor")
    const investorsCategories = categories.filter((cat) => cat?.for === "investor")

    let [type, setType] = useState();
    let [stepNo, setStepNo] = useState(1);
    let [company, setCompany] = useState({});
    let [partnerId, setPartnerId] = useState();
    let [animation, setAnimation] = useState(1);
    let [isAgreed, setIsAgreed] = useState(false);
    let [attachment, setAttachment] = useState([]);
    let [isNotSure, setIsNotSure] = useState(false);
    let [isLoading, setIsLoading] = useState(false);
    let [isBtnHover, setIsBtnHover] = useState(false);
    let [registerAs, setRegisterAs] = useState("User");
    let [isGuestUser, setIsGuestUser] = useState(false);

    let [advisorType, setAdvisorType] = useState(false);
    let [passwordType, setPasswordType] = useState(true);
    let [companyOptions, setCompanyOptions] = useState([]);
    let [companySelected, setCompanySelected] = useState({});
    let [advisorHashData, setAdvisorHashData] = useState("");
    let [existingAdvisor, setExistingAdvisor] = useState({});
    let [websiteStatus, setWebsiteStatus] = useState("Check");
    let [advisorTypeValue, setAdvisorTypeValue] = useState("");
    let [selectedAdvisorType, setSelectedAdvisorType] = useState(null);

    let [investorType, setInvestorType] = useState(false);
    let [selectedInvestorType, setSelectedInvestorType] = useState(null);

    let [isValidPassword, setIsValidPassword] = useState(false);
    let [confirmPasswordType, setConfirmPasswordType] = useState(true);
    let [passwordError, setPasswordError] = useState({ password: "", confirmPassword: "", });
    let [formData, setFormData] = useState({ role: "", firstName: "", lastName: "", email: selectedCompany["companyEmail"] || "", password: "", confirmPassword: "", title: "", phone: "", firmName: "", company5Words: "", firmAddress: "", website: "", firmLogo: "", testType: "", });

    let searchTimeout;
    let formCheck = ["firstName", "lastName", "email", "password", "confirmPassword",];
    let passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+{}[\]|\\:;"'<>,.?/~`])[A-Za-z\d!@#$%^&*()\-_=+{}[\]|\\:;"'<>,.?/~`]+$/;

    useEffect(() => {
        let pathname = window.location.pathname;
        if (pathname.includes('register')) {
            let userAgent = navigator.userAgent || navigator.vendor || window.opera;
            let mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
            let isMobile = mobileRegex.test(userAgent);
            if (isMobile) dispatch(toggleModal({ open: 'mobileDevicesPopup' }));
        }
    }, []);

    useEffect(() => {
        if (location?.hash) {
            partnerId = location?.hash.split('?')[0];
            partnerId = partnerId.replaceAll('#', '');
            if (partnerId) setPartnerId(partnerId);

            type = location?.hash.split('?')[1];
            if (type == 'Superflow') setType(type);
        }
        if (localStorage.getItem("companyId")) getUser();
        if (localStorage.getItem("isPartnerChecklist")) {
            setRegisterAs("User");
            if (!partner["referralCode"]) {
                let partnerId = localStorage.getItem("partnerId");
                if (partnerId) getPartner(partnerId);
            } else
                setFormData({ ...formData, referralCode: partner["referralCode"] });
        }
    }, []);

    useEffect(() => {
        let companyId = localStorage.getItem("companyId");
        if (user?.['role'] == 'Guest' && companyId) setIsGuestUser(true);
        else setIsGuestUser(false);
    }, [user]);

    useEffect(() => {
        if (selectedCompany["companyEmail"])
            setFormData({ ...formData, email: selectedCompany["companyEmail"] });
    }, [selectedCompany]);

    const getUser = async () => {
        let response = await getRequest(`/user`);
        if (response && response['code'] == 200) {
            let user = response?.['body']?.['user'];
            dispatch(updateUser(user));
        }
    };

    const getPartner = async (id) => {
        let res = await getRequest(`/checklist/partner/${id}`);
        if (res["code"] == 200) {
            dispatch(updatePartner(res["body"]));
            setFormData({ ...formData, referralCode: res["body"]["referralCode"] });
        }
    };

    const CustomOption = (props) => {
        const { data, innerRef, innerProps } = props;
        return data.hasAdd ? (
            <div
                className="df jcsb aic"
                ref={innerRef}
                {...(advisorTypeValue ? innerProps : {})}
            >
                <div
                    style={{
                        marginLeft: "11px",
                        color: advisorTypeValue === "" && "gray",
                    }}
                >
                    {data.label}
                </div>
                <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="span"
                    onClick={(event) => {
                        event.stopPropagation();
                        event.preventDefault();
                        dispatch(toggleModal({ open: "advisorType" }));
                    }}
                >
                    <PlusIcon />
                </IconButton>
            </div>
        ) : (
            <>
                <components.Option {...props} />
            </>
        );
    };

    // Custom react select
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            cursor: "pointer",
            border: "none",
            boxShadow: "none",
            minHeight: "initial",
            background: "transparent",
        }),
        valueContainer: (provided) => ({
            ...provided,
        }),
        input: (provided) => ({
            ...provided,
            margin: 0,
            padding: 0,
        }),
        placeholder: (provided) => ({
            ...provided,
            margin: 0,
            padding: 0,
            fontSize: "14px",
            color: "#9aa3b4",
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            padding: 0,
        }),
        indicatorSeparator: () => ({
            display: "none",
        }),
        menu: (provided, state) => ({
            ...provided,
            width: "100%",
            marginTop: 4,
            fontSize: "13px",
            zIndex: 20,
        }),
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected
                ? "#fc7785"
                : state.isFocused
                    ? "#fde3e6"
                    : provided.backgroundColor,
            color: state.isSelected ? "white" : provided.color,
            fontSize: "13px",
            ":active": {
                ...provided[":active"],
                backgroundColor: state.isSelected ? "#fc7785" : "#fde3e6",
            },
        }),
    };

    useEffect(() => {
        let pathname = window.location.pathname;
        if (pathname && pathname == "/register") setIsNotSure(false);
        else setIsNotSure(true);

        registerAs = localStorage.getItem('registerAs');
        if (registerAs) setRegisterAs(registerAs);
        if (registerAs == 'Advisor') setAdvisorType(true);
        if (registerAs == 'Investor') setInvestorType(true)
        const timeout = setTimeout(() => {
            setAnimation(true);
        }, 2000);
        return () => clearTimeout(timeout);
    }, []);

    useEffect(() => {
        if (dispatch) {
            dispatch(fetchCategories());
        }
    }, [dispatch]);

    //Reseting all advisor type select to intial if radio button change
    useEffect(() => {
        setSelectedAdvisorType(null);
        setAdvisorTypeValue("");
        setSelectedInvestorType(null);
    }, [registerAs]);

    //Handle on advisor type added
    const onAdvisorTypeAdded = async () => {
        let res = await postRequest(`/admin/create/custom-category`, {
            name: advisorTypeValue,
        });
        if (res?.code === 200) {
            showMessage(res["message"]);
            dispatch(toggleModal({ open: "" }));
            const newCategories = res?.body
                ? {
                    ...res.body,
                    label: res.body.name,
                    value: res.body._id,
                }
                : {};
            dispatch(UPDATE_CATEGORIES([newCategories, ...categories]));
        }
    };

    //On advisor modal close
    const onAdvisorModalClose = () => {
        dispatch(toggleModal({ open: "" }));
        setSelectedAdvisorType(null);
        setAdvisorTypeValue("");
    };

    useEffect(() => {
        setFormData({ ...formData, role: registerationType });
    }, []);

    useEffect(() => {
        if (!formData?.["firmName"] || formData?.["firmName"] == "") {
            setCompanyOptions([]);
            setCompanySelected({});
        }
    }, [formData?.["firmName"]]);

    const resetStates = () => {
        setStepNo(1);
        setIsAgreed(false);
        setCompanyOptions([]);
        setCompanySelected({});
        setWebsiteStatus("Check");
        setIsValidPassword(false);
        setFormData({
            role: "",
            firstName: "",
            lastName: "",
            email: "",
            password: "",
            confirmPassword: "",
            title: "",
            phone: "",
            firmName: "",
            firmAddress: "",
            website: "",
            firmLogo: "",
        });
    };

    const handleRegisterAs = (value) => {
        setAdvisorType(value === "Advisor");
        setInvestorType(value === "Investor");

        setRegisterAs(value);
        setFormData({ ...formData, role: value });
        setStepNo(1);
        setIsAgreed(false);
        setCompanyOptions([]);
        setCompanySelected({});
        setWebsiteStatus("Check");
        trackButtonClick('register_as_selection', {
            registration_type: value,
            step: stepNo
        });
    };

    const validatePasswords = (password, confirmPassword, showErrors = true) => {
        let errors = { password: "", confirmPassword: "" };

        if (!password || password.length < 8) {
            errors["password"] = "Password must be 8 characters long";
        } else if (!passwordPattern.test(password)) {
            errors["password"] = "Combination of uppercase, lowercase, digit & special character is required";
        }

        if (!confirmPassword) {
            errors["confirmPassword"] = showErrors ? "Please confirm your password" : "";
        } else if (password !== confirmPassword) {
            errors["confirmPassword"] = "Password and Confirm Password don't match";
        }

        const isValid = !errors["password"] && password === confirmPassword && !!password && !!confirmPassword;
        if (showErrors) setPasswordError(errors);
        else setPasswordError({ password: "", confirmPassword: "" });
        setIsValidPassword(isValid);
        return isValid;
    };

    const handlePasswordBlur = () => {
        // Reason: re-validate on blur so error messages show after the user leaves the field
        validatePasswords(formData?.["password"] || "", formData?.["confirmPassword"] || "", true);
    };

    const searchCompany = async (input) => {
        if (!input) return;

        const response = await getRequest(`/company/search/${input}`);
        if (!response || response["code"] != 200) return;
        setCompanyOptions(response["body"]["items"].slice(0, 5));
    };

    const searchCompanyTimeout = (e) => {
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => searchCompany(e.target.value), 1000);
    };

    const requestAdvisorAccess = async () => {
        trackButtonClick('request_advisor_access');
        let data = {
            firmId: existingAdvisor["_id"],
            firmName: existingAdvisor["cName"],
            contactId: existingAdvisor["contactId"],
            contactName: existingAdvisor["contactName"],
            contactEmail: existingAdvisor["contactEmail"],
            userFirstName: formData["firstName"],
            userLastName: formData["lastName"],
            userEmail: formData["email"],
        };

        let response = await postRequest(`/company/requestInvestorAccess`, data);
        if (response["code"] == 200) {
            showMessage(response["message"]);
            dispatch(toggleModal({ open: "" }));
            resetStates();
        }
    };

    const isURL = (str) => {
        var pattern = new RegExp(
            "^((ft|htt)ps?:\\/\\/)?" + // protocol
            "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name and extension
            "((\\d{1,3}\\.){3}\\d{1,3}))" + // OR ip (v4) address
            "(\\:\\d+)?" + // port
            "(\\/[-a-z\\d%@_.~+&:]*)*" + // path
            "(\\?[;&a-z\\d%@_.,~+&:=-]*)?" + // query string
            "(\\#[-a-z\\d_]*)?$",
            "i"
        ); // fragment locator
        return pattern.test(str);
    };

    const openWindow = (url) => {
        if (window.innerWidth <= 640) {
            var a = document.createElement("a");
            a.setAttribute("href", url);
            a.setAttribute("target", "_blank");

            var dispatch = document.createEvent("HTMLEvents");
            dispatch.initEvent("click", true, true);

            a.dispatchEvent(dispatch);
        } else {
            var width = window.innerWidth * 0.8;
            var height = (width * window.innerHeight) / window.innerWidth;
            window.open(url, "newwindow", "width=" + width + ", height=" + height + ", top=" + (window.innerHeight - height) / 2 + ", left=" + (window.innerWidth - width) / 2);
        }
        return false;
    };

    const verifyWebsite = async () => {
        trackButtonClick('verify_website', {
            website: formData['website']
        });
        try {
            let companyWebsite = document.querySelector(`#companyWebsite`).value;
            if (!companyWebsite) return showMessage("Please provide website link");
            if (!isURL(companyWebsite)) return showMessage("Invalid company url");

            if (companyWebsite.indexOf("http") < 0)
                companyWebsite = `http://${companyWebsite}`;

            openWindow(companyWebsite);
            setWebsiteStatus("Confirm");
        } catch (e) {
            return showMessage(e);
        }
    };

    const onDragOver = (e) => e.preventDefault();
    const onDrop = (e) => {
        e.preventDefault();
        const logo = e.dataTransfer.files[0];
        let maxSizeInBytes = 5 * 1024 * 1024;
        if (logo) {
            let logoUrl = URL.createObjectURL(logo);
            let img = document.createElement("img");
            img.src = logoUrl;
            img.onload = () => {
                if (logo.size > maxSizeInBytes)
                    showMessage(`File size must be less than 1MB`);
                else
                    setFormData((prevFormData) => ({
                        ...prevFormData,
                        firmLogo: logoUrl,
                    }));
            };
        }
        trackButtonClick('register_image_drop', {
            step: stepNo,
            file_type: e.dataTransfer.files[0]?.type
        });
    };

    const handleImageChange = async (event) => {
        let logo = event.target.files[0];
        if (event.target.files) {
            const newAttachment = [];
            for (const file of event.target.files) {
                newAttachment.push(file);
            }
            setAttachment(newAttachment);
        }

        let maxSizeInBytes = 5 * 1024 * 1024;
        if (logo) {
            let logoUrl = URL.createObjectURL(logo);
            let img = document.createElement("img");
            img.src = logoUrl;
            img.onload = () => {
                if (logo.size > maxSizeInBytes)
                    showMessage(`File size must be less than 5Mb`);
                else
                    setFormData((prevFormData) => ({
                        ...prevFormData,
                        firmLogo: logoUrl,
                    }));
            };
        }
        trackButtonClick('register_image_upload', {
            step: stepNo,
            file_type: event.target.files[0]?.type
        });
    };

    const restrictedForDevices = () => {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const mobileRegex =
            /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
        const isMobile = mobileRegex.test(userAgent);
        return isMobile;
    };

    const handleNextRegister = async () => {
        if (restrictedForDevices()) {
            return showMessage("You can Login/Register on Laptop");
        }
        if (registerAs == "") return showMessage("Please select Register as");
        if (registerAs === "Advisor" && !selectedAdvisorType)
            return showMessage("Please select the advisor type");
        let stage = localStorage.getItem("cStage");
        let testType = localStorage.getItem("testType");

        if (stepNo == 1) {
            let isError = false;
            const data = formCheck?.map((field, i, arr) => {
                if (formData?.[field] !== "") return false;
                return true;
            });

            if (!isError && passwordError["password"] == "" && passwordError["confirmPassword"] == "") {
                if (data.includes(true)) showMessage("Please fill out all fields");
                else {
                    if (!isAgreed) return showMessage("Please accept the terms & conditions");

                    if (isGuestUser && (registerAs == "Advisor" || registerAs == "Investor")) {
                        let companyId = localStorage.getItem("companyId");
                        setIsLoading(true);
                        const response = await postRequest("/user/advisor2MTFHP", {
                            firstName: formData?.["firstName"],
                            lastName: formData?.["lastName"],
                            email: formData?.["email"],
                            password: formData?.["password"],
                            role: registerAs,
                            companyId: companyId,
                        });

                        if (response && response["code"] == 200) {
                            if (registerPage) {
                                const hash = response["body"];
                                dispatch(setLoginType({ emailEnabled: true, hash }));
                            } else {
                                dispatch(toggleModal({ open: "registerVerification" }));
                            }
                            showMessage(response["message"]);
                            resetStates();
                        }
                        setIsLoading(false);
                    }
                    else if (registerAs == "User") {
                        setIsLoading(true);
                        let data = { firstName: formData?.["firstName"], lastName: formData?.["lastName"], email: formData?.["email"], password: formData?.["password"], referralCode: formData?.["referralCode"], }

                        if (type && partnerId) data = { firstName: formData?.["firstName"], lastName: formData?.["lastName"], email: formData?.["email"], password: formData?.["password"], referralCode: formData?.["referralCode"], type, partnerId }

                        const response = await postRequest("/user", data);
                        if (response && response["code"] == 200) {
                            if (registerPage) {
                                const hash = response["body"];
                                dispatch(setLoginType({ emailEnabled: true, hash }));
                            } else {
                                dispatch(toggleModal({ open: "registerVerification" }));
                            }
                            showMessage(response["message"]);
                            resetStates();
                        }
                        setIsLoading(false);
                    }
                    else {
                        const response = await postRequest("/user/checkExistingUser", {
                            email: formData?.["email"],
                        });
                        if (response && response["code"] == 200) {
                            if ((registerAs == "Advisor" || registerAs == "Investor") && !isGuestUser && company?.["cName"] && company?.["cWebsite"]) {
                                setFormData({
                                    ...formData,
                                    role: registerAs,
                                    cType: company["cType"],
                                    firmName: company["cName"],
                                    website: company["cWebsite"],
                                    ukRegNo: company["ukRegNo"],
                                    firmAddress: company["cAddress"],
                                    doIncorporation: company["doIncorporation"],
                                    testType: testType ? testType : "investment",
                                    cStage: stage ? stage : "Mature",
                                });
                                setStepNo(3);
                                setWebsiteStatus("Confirmed");
                            } else setStepNo(2);
                        }
                    }
                }
            }
        }
        else if (stepNo == 2 && !isGuestUser) {
            if (companySelected && companySelected["title"]) {
                let response = await postRequest(`/company/checkExistingCompany`, {
                    ukRegNo: companySelected["company_number"],
                });
                if (response["code"] == 200) {
                    if (Object.keys(response["body"]).length > 0) {
                        if ([formData['role']].includes(response["body"]?.["cCategory"])) {
                            showMessage(response["message"]);
                            setExistingAdvisor(response["body"]);
                            dispatch(toggleModal({ open: "existingAdvisor" }));
                        } else
                            showMessage(`${response["body"]?.["cName"]} is a ${response["body"]?.["cCategory"]} company. You can't add it.`);
                    } else {
                        setStepNo(3);
                        setFormData({
                            ...formData,
                            role: registerAs,
                            cType: companySelected["testType"],
                            firmName: companySelected["title"],
                            ukRegNo: companySelected["company_number"],
                            firmAddress: companySelected["address_snippet"],
                            doIncorporation: companySelected["date_of_creation"],
                            testType: testType ? testType : "investment",
                            cStage: stage ? stage : "Mature",
                        });
                    }
                }
            }
        }
        else if (stepNo == 3 && !isGuestUser) {
            if (formData["firmName"] === "") showMessage("Please fill out Firm Name");
            else if (formData["firmAddress"] === "")
                showMessage("Please fill out the Firm Address");
            else if (formData["title"] === "")
                showMessage("Please fill out your role or job Title");
            else if (formData["phone"] === "")
                showMessage("Please fill out phone Number");
            else if (formData["website"] === "")
                showMessage("Please fill out the website");
            else if (formData["company5Words"].split(" ").length < 5)
                showMessage(
                    `Please provide 5 words that describe your ${registerAs == "Advisor" || registerAs == "Investor" ? "client" : ""
                    } company business activites`
                );
            else if (!validator.isURL(formData["website"]))
                showMessage("Please enter valid webiste URL");
            else if (websiteStatus != "Confirmed")
                showMessage("Please check and confirm company website");
            else {
                const response = await postRequest("/user/advisor", { attachment, ...formData, isParent: true, ...(registerAs == "Investor" ? { investorType: selectedInvestorType?.value } : { advisorType: selectedAdvisorType?.value }) }, false);
                if (response && response["code"] == 200) {
                    setCompany(response["body"]["newCompany"]);
                    setAdvisorHashData(response["body"]?.["hash"]);
                    setCompanySelected(response["body"]?.["newCompany"]);
                    dispatch(
                        updateCompany({
                            companySelected: response["body"]?.["newCompany"],
                            company: response["body"]?.["newCompany"],
                        })
                    );
                    if (response["body"]?.["newCompany"]?.["companyDescription"])
                        dispatch(toggleModal({ open: "descriptionPopup" }));
                    showMessage(response["message"]);
                    resetStates();
                }
                setIsLoading(false);
            }
        }
    };

    const handleBack = () => {
        if (stepNo == 2) {
            if (companySelected && companySelected["title"]) setCompanySelected({});
            else setStepNo(1);
        } else setStepNo(stepNo - 1);
    };

    const handleLogin = () => {
        trackButtonClick('register_to_login_redirect');
        navigate('/login');
    };

    return (
        <>
            <div className="lp-auth-main">
                <div className="lp-auth-glow lp-auth-glow--tr" aria-hidden="true" />
                <div className="lp-auth-glow lp-auth-glow--bl" aria-hidden="true" />

                <div className="lp-auth-wrap">
                    <div className="lp-auth-card">
                        <h1 className="lp-auth-title">Register with</h1>
                        <h1 className="lp-auth-title pink">Diligentsia for FREE</h1>

                        {stepNo == 1 ? (
                            <>
                                <div className="lp-auth-row">
                                    <div className="lp-auth-field">
                                        <span className="icon"><IconUser /></span>
                                        <input
                                            id="firstName"
                                            type="text"
                                            placeholder="First Name"
                                            value={formData?.["firstName"] || ""}
                                            onChange={(e) => {
                                                if (restrictedForDevices()) { return showMessage("You can Login/Register on Laptop"); }
                                                setFormData({ ...formData, firstName: e["target"]["value"] });
                                            }}
                                        />
                                    </div>
                                    <div className="lp-auth-field">
                                        <span className="icon"><IconUser /></span>
                                        <input
                                            id="lastName"
                                            type="text"
                                            placeholder="Last Name"
                                            value={formData?.["lastName"] || ""}
                                            onChange={(e) => {
                                                if (restrictedForDevices()) { return showMessage("You can Login/Register on Laptop"); }
                                                setFormData({ ...formData, lastName: e["target"]["value"], });
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="lp-auth-field lp-auth-field--icon-wide">
                                    <span className="icon"><IconMail /></span>
                                    <input
                                        id="email"
                                        type="email"
                                        placeholder="Email - your company email address only please"
                                        value={formData?.["email"] || ""}
                                        onChange={(e) => {
                                            if (restrictedForDevices()) { return showMessage("You can Login/Register on Laptop"); }
                                            setFormData({ ...formData, email: e["target"]["value"] });
                                        }}
                                    />
                                </div>

                                <div className="lp-auth-row">
                                    <div>
                                        <div className="lp-auth-field lp-auth-field--pw">
                                            <span className="icon"><IconLock /></span>
                                            <input
                                                id="password"
                                                type={passwordType ? "password" : "text"}
                                                placeholder="Password"
                                                value={formData?.["password"] || ""}
                                                onChange={(e) => {
                                                    if (restrictedForDevices()) { return showMessage("You can Login/Register on Laptop"); }
                                                    const password = e["target"]["value"];
                                                    setFormData({ ...formData, password });
                                                    // Reason: validate with the new value immediately — formData is still stale in this handler
                                                    validatePasswords(password, formData?.["confirmPassword"] || "", false);
                                                }}
                                                onBlur={handlePasswordBlur}
                                                required
                                            />
                                            <button type="button" className="toggle-pw" onClick={() => setPasswordType(!passwordType)}>
                                                {passwordType ? <IconEye /> : <IconEyeOff />}
                                            </button>
                                        </div>
                                        {passwordError["password"] && <div className="lp-auth-error">{passwordError["password"]}</div>}
                                    </div>
                                    <div>
                                        <div className="lp-auth-field lp-auth-field--pw">
                                            <span className="icon"><IconLock /></span>
                                            <input
                                                id="confirmPassword"
                                                type={confirmPasswordType ? "password" : "text"}
                                                placeholder="Confirm Password"
                                                value={formData?.["confirmPassword"] || ""}
                                                onChange={(e) => {
                                                    if (restrictedForDevices()) { return showMessage("You can Login/Register on Laptop"); }
                                                    const confirmPassword = e["target"]["value"];
                                                    setFormData({ ...formData, confirmPassword });
                                                    // Reason: validate with the new value immediately — formData is still stale in this handler
                                                    validatePasswords(formData?.["password"] || "", confirmPassword, false);
                                                }}
                                                onBlur={handlePasswordBlur}
                                                required
                                            />
                                            <button type="button" className="toggle-pw" onClick={() => setConfirmPasswordType(!confirmPasswordType)}>
                                                {confirmPasswordType ? <IconEye /> : <IconEyeOff />}
                                            </button>
                                        </div>
                                        {passwordError["confirmPassword"] && <div className="lp-auth-error">{passwordError["confirmPassword"]}</div>}
                                    </div>
                                </div>

                                <div className="lp-register-as">
                                    <p>Register as</p>
                                    <div className="lp-register-as-row">
                                        <label className="lp-register-radio">
                                            <input
                                                id="user"
                                                name="registerAs"
                                                type="radio"
                                                value="User"
                                                checked={registerAs == "User"}
                                                onChange={(e) => { handleRegisterAs(e["target"]["value"]) }}
                                            />
                                            Company
                                        </label>
                                        <label className={`lp-register-radio ${type == 'Superflow' ? 'is-disabled' : ''}`}>
                                            <input
                                                id="advisor"
                                                type="radio"
                                                value="Advisor"
                                                name="registerAs"
                                                checked={registerAs == "Advisor"}
                                                onChange={(e) => { type !== 'Superflow' && handleRegisterAs(e["target"]["value"]) }}
                                            />
                                            Advisor
                                        </label>
                                        <label className={`lp-register-radio ${type == 'Superflow' ? 'is-disabled' : ''}`}>
                                            <input
                                                id="investor"
                                                type="radio"
                                                value="Investor"
                                                name="registerAs"
                                                checked={registerAs == "Investor"}
                                                onChange={(e) => { type !== 'Superflow' && handleRegisterAs(e["target"]["value"]) }}
                                            />
                                            Investor
                                        </label>
                                    </div>
                                    {advisorType ? (
                                        <div className="lp-register-select" style={{ marginTop: 12 }}>
                                            <Select
                                                placeholder="Select Advisor Type"
                                                styles={customStyles}
                                                value={selectedAdvisorType}
                                                className="react-select-container"
                                                components={{ Option: CustomOption }}
                                                options={advisorsCategories}
                                                onChange={(value) => { setSelectedAdvisorType(value) }}
                                            />
                                        </div>
                                    ) : null}
                                    {investorType ? (
                                        <div className="lp-register-select" style={{ marginTop: 12 }}>
                                            <Select
                                                placeholder="Select Investor Type"
                                                styles={customStyles}
                                                value={selectedInvestorType}
                                                className="react-select-container"
                                                components={{ Option: CustomOption }}
                                                options={investorsCategories}
                                                onChange={(value) => { setSelectedInvestorType(value) }}
                                            />
                                        </div>
                                    ) : null}
                                </div>

                                <div className="lp-register-terms">
                                    <label htmlFor="registerTerms">
                                        <input
                                            id="registerTerms"
                                            type="checkbox"
                                            checked={isAgreed}
                                            onChange={() => setIsAgreed(!isAgreed)}
                                        />
                                        <span>
                                            I agree to the <Link to="/terms-conditions" target="_blank">terms and conditions</Link> and <Link to="/policy" target="_blank">policies</Link>
                                        </span>
                                    </label>
                                </div>
                            </>
                        ) : stepNo == 2 && !isGuestUser ? (
                            <>
                                {Object.keys(companySelected).length == 0 && (
                                    <div className="lp-auth-field lp-auth-field--icon-wide" style={{ marginBottom: 16 }}>
                                        <span className="icon"><IconSearch /></span>
                                        <input
                                            id="searchCompany"
                                            name="firmName"
                                            type="text"
                                            placeholder={registerAs == "User" ? "Please add the name of your company" : "Please add the name of YOUR UK firm/company, NOT your client/investee company"}
                                            value={formData?.["firmName"] || ""}
                                            onChange={(e) => setFormData({ ...formData, firmName: e["target"]["value"], })}
                                            onKeyUp={searchCompanyTimeout}
                                        />
                                    </div>
                                )}

                                {companySelected && companySelected["title"] ? (
                                    <div className="lp-register-company-card">
                                        <h2>Company Info</h2>
                                        <span><b>Company Status:</b> {companySelected["company_status"]?.toUpperCase()}</span>
                                        <span><b>Company Number:</b> {companySelected["company_number"]}</span>
                                        <span><b>Company Title:</b> {companySelected["title"]}</span>
                                        <span><b>Company Date of Creation:</b> {companySelected["date_of_creation"]}</span>
                                        <span><b>Company Description:</b> {companySelected["description"]}</span>
                                        <span><b>Company Address:</b> {companySelected["address_snippet"]}</span>
                                    </div>
                                ) : formData?.["firmName"] != "" && companyOptions.length > 0 ? (
                                    <div className="lp-register-search-results">
                                        {companyOptions.map((option, idx) => (
                                            <div key={idx} onClick={() => setCompanySelected(option)} className="lp-register-search-row">
                                                <span className="name">{option["title"]}</span>
                                                <span className="num">{option["company_number"]}</span>
                                                <span className="status">{option["company_status"]}</span>
                                            </div>
                                        ))}
                                    </div>
                                ) : null}
                            </>
                        ) : stepNo == 3 && !isGuestUser ? (
                            <>
                                <div className="lp-auth-field lp-auth-field--icon-wide">
                                    <span className="icon"><IconBuilding /></span>
                                    <input
                                        id="firmName"
                                        name="firmName"
                                        type="text"
                                        placeholder="Firm Name"
                                        value={formData?.["firmName"] || ""}
                                        onChange={(e) => setFormData({ ...formData, firmName: e["target"]["value"], })}
                                    />
                                </div>
                                <div className="lp-auth-field lp-auth-field--icon-wide">
                                    <span className="icon"><IconMapPin /></span>
                                    <input
                                        id="firmAddress"
                                        name="firmAddress"
                                        type="text"
                                        placeholder="Firm Address"
                                        value={formData?.["firmAddress"] || ""}
                                        onChange={(e) => setFormData({ ...formData, firmAddress: e["target"]["value"] })}
                                    />
                                </div>
                                <div className="lp-auth-field lp-auth-field--icon-wide">
                                    <span className="icon"><IconBriefcase /></span>
                                    <input
                                        id="title"
                                        name="title"
                                        type="text"
                                        placeholder="Your Title"
                                        value={formData?.["title"] || ""}
                                        onChange={(e) => setFormData({ ...formData, title: e["target"]["value"] })}
                                    />
                                </div>
                                <div className="lp-auth-field lp-auth-field--icon-wide">
                                    <span className="icon"><IconPhone /></span>
                                    <Input
                                        name="phone"
                                        country="GB"
                                        international
                                        placeholder="Your Phone Number"
                                        withCountryCallingCode
                                        value={formData?.["phone"]}
                                        onChange={(e) => setFormData({ ...formData, phone: e })}
                                    />
                                </div>

                                <div className="lp-register-verify-row">
                                    <div className="lp-auth-field lp-auth-field--icon-wide">
                                        <span className="icon"><IconGlobe /></span>
                                        <input
                                            id="companyWebsite"
                                            name="website"
                                            type="text"
                                            placeholder="Website"
                                            value={formData?.["website"] || ""}
                                            onChange={(e) => { setFormData({ ...formData, website: e["target"]["value"] }); setWebsiteStatus("Check") }}
                                        />
                                    </div>
                                    {websiteStatus == "Check" ? (
                                        <button type="button" className="lp-register-verify-btn" onClick={() => verifyWebsite()}>Check</button>
                                    ) : websiteStatus == "Confirm" ? (
                                        <button type="button" className="lp-register-verify-btn is-confirm" onClick={() => setWebsiteStatus("Confirmed")}>Confirm</button>
                                    ) : (
                                        <button type="button" className="lp-register-verify-btn is-confirmed">Confirmed</button>
                                    )}
                                </div>

                                <div className="lp-auth-field lp-auth-field--icon-wide">
                                    <span className="icon"><IconTag /></span>
                                    <input
                                        id="company5Words"
                                        name="company5Keywords"
                                        type="text"
                                        placeholder={`Add 5 keywords which define this company's activities`}
                                        value={formData?.["company5Words"]}
                                        onChange={(e) => setFormData({ ...formData, company5Words: e["target"]["value"] })}
                                    />
                                </div>

                                <div className="lp-register-logo-field">
                                    <span className="lbl">Firm Logo</span>
                                    {formData?.["firmLogo"] == "" ? (
                                        <label onDragOver={onDragOver} onDrop={(e) => onDrop(e)} htmlFor="fileUpload" className="dz">
                                            <IconUpload />
                                            <span>Click here or drag and drop files (Max 5MB)</span>
                                            <input onChange={handleImageChange} style={{ display: 'none' }} id="fileUpload" type="file" accept="image/*" />
                                        </label>
                                    ) : (
                                        <div className="preview">
                                            <button type="button" className="remove" onClick={() => setFormData((prevFormData) => ({ ...prevFormData, firmLogo: "" }))}>
                                                <IconX />
                                            </button>
                                            <img src={formData["firmLogo"]} alt="Firm Logo" />
                                        </div>
                                    )}
                                </div>
                            </>
                        ) : null}

                        <div className="lp-auth-actions">
                            {registerAs != "User" && stepNo != 1 && (
                                <button type="button" className="lp-auth-back" onClick={() => handleBack()}>
                                    <IconArrowLeft /> Back
                                </button>
                            )}
                            {stepNo == 2 && !(companySelected && companySelected["title"]) ? null : (
                                <button
                                    type="button"
                                    style={{ padding: '10px' }}
                                    className={`lp-auth-submit ${(isLoading || (stepNo == 1 && !isValidPassword)) ? 'is-disabled' : ''}`}
                                    disabled={isLoading || (stepNo == 1 && !isValidPassword)}
                                    onClick={() => { if (!isLoading && !(stepNo == 1 && !isValidPassword)) { handleNextRegister(); } }}
                                >
                                    {(!isGuestUser && (registerAs == "Advisor" || registerAs == "Investor")) ? ((stepNo === 1 || stepNo === 2) ? "Next" : "Register")
                                        : stepNo === 1 && registerAs === "User"
                                            ? "Register for free"
                                            : "Register"
                                    }
                                </button>
                            )}
                        </div>

                        <p className="lp-auth-fine">No credit card required</p>

                        <p className="lp-auth-foot">
                            Already registered? <Link to={ROUTES.LOGIN} onClick={() => handleLogin()}>Log in</Link>
                        </p>
                    </div>

                    <p className="lp-auth-trust">Trusted by 50+ investors, advisors &amp; companies · No credit card required</p>

                    {/* Not Sure Section */}
                    {isNotSure && (
                        <div className="not-sure-register w40">
                            <div className="pr bg20 not-sure-container" style={{ padding: "0px 160px", background: 'transparent', height: "100%" }}>
                                <div ref={refs?.current?.[8]} className={`tslp op1 tty0`}>
                                    <p className="fw500 tac c15 pt3rem fs2rem" style={{ lineHeight: "1" }}>
                                        Not Sure <span className="c23">Yet?</span>
                                    </p>
                                    <div className="w100 df jcc">
                                        <p className="fw400 tac c15 pt0-5rem fs1rem" style={{ lineHeight: "24px", width: "100%" }}>
                                            Find out by taking our FREE 2-minute Diligentsia Test. No email or credit card required.
                                        </p>
                                    </div>
                                </div>
                                <div className="df jcc fdc w90 mt10rem bsbb smw100 mxa">
                                    <div
                                        ref={refs?.current?.[8]}
                                        className={`bsflp bsbb bg1 br30px pr tslp pt1rem pb1rem pr1rem pl1rem df aic fdc mb3-5rem smw70 smmxa ${isAnimationVisible[8] && "scaleAnimation"}`}
                                        style={{ width: "100%" }}
                                    >
                                        <div className="pa df jcc aic p2rem bg3 twoMinuteIcon" style={{ top: "-49px", left: "50%", transform: "translateX(-50%)", width: "15px", height: "15px", zoom: "0.8", borderRadius: "50%" }}>
                                            <img src={require(`../../../../images/2-minute-test-icon.png`)} alt="2-minute-test-icon" />
                                        </div>
                                        <h1 className="fw500 tac c15 fs1-25rem pr0-5rem pl0-5rem mt1rem df fdc">
                                            <div>
                                                How <span className="fw700 fs1-25rem tac c15 fsi">Investment, Growth or Exit Ready</span> are you?
                                            </div>
                                        </h1>
                                        <div className="df jcc my0-5rem">
                                            <Link
                                                to={`/testPage`}
                                                onMouseEnter={() => setIsBtnHover(true)}
                                                onMouseLeave={() => setIsBtnHover(false)}
                                                className={`br35px pr cp c1-hover c4 df jcc aic bg1 bg4-hover`}
                                                style={{ transition: "background-color 0.3s ease", border: "1px solid #FC7785", padding: "10px 26px" }}
                                            >
                                                2-Minute Test
                                                <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ marginLeft: "10px", stroke: isBtnHover ? "#ffff" : "#FC7785", height: "18px", width: "21px" }}>
                                                    <path
                                                        d="M1.39612 10.331H15.818L11.43 14.7191C10.1696 15.9795 12.0602 17.87 13.3206 16.6096L17.3169 12.6071L19.9847 9.93519C20.5017 9.41507 20.5017 8.57507 19.9847 8.05496L13.3206 1.38311C13.0671 1.12258 12.7181 0.976392 12.3545 0.979416C11.1542 0.979567 10.5652 2.4415 11.43 3.2738L15.8284 7.66187H1.32711C-0.521408 7.75359 -0.383387 10.4231 1.39612 10.331Z"
                                                        fill={isBtnHover ? "#ffff" : "#FC7785"}
                                                    />
                                                </svg>
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <ModalWrapper modalCardClasses={"m0rem"} modalType={"existingAdvisor"} onCloseHandler={() => { setExistingAdvisor({}), setStepNo(2), dispatch(toggleModal({ open: "" })) }}>
                <img className="h3rem t0 l0 m1rem" src={require(`../../../../images/logo.svg`)} alt="TODO" />
                <h2 className="c15 fw600">{`Existing ${registerAs} - ${existingAdvisor["cName"]}`}</h2>
                <div className="tac my1rem oa">
                    <p className="fs1rem taj px0-5rem c43">
                        Hi {`${formData["firstName"]} ${formData["lastName"]}`}, <br />
                        We will notify <b>{existingAdvisor["contactName"]} </b> of your
                        wish to add your Diligentsia account and request that they grant
                        you access. <br />
                        <br />
                        Please click below REQUEST to grant for access
                        <br />
                        Kind Regards{" "}
                    </p>
                </div>
                <div className="df jcse">
                    <button onClick={() => requestAdvisorAccess()} className="bg3 c1 h100 mt0-5rem shadow td250 br5px px2rem fs1rem py0-5rem fw600 cp ttu bsbb tac df jcc aic">Request</button>
                </div>

            </ModalWrapper>

            {/* Description Popup */}
            <ModalWrapper modalCardClasses={"m0rem"} modalType={"descriptionPopup"}
                girlComponent={
                    <div style={{ position: "relative", maxHeight: "90%" }}>
                        <img src="https://repository-diligentsia.s3.ap-northeast-1.amazonaws.com/development/girl-1730109127115.webp" alt="messageLadie" className="girlImage" />
                        <img onClick={() => { dispatch(toggleModal({ open: "introVideo" })); dispatch(setModalHistory({ modalHistory: modal["open"] })) }}
                            src={require(`../../../../images/clicktohearme.webp`)}
                            className="pa cp"
                            alt="clickToHearMe"
                            style={{ maxWidth: "130px", zIndex: 99, top: "-210px", left: "15px" }}
                        />
                    </div>
                }>
                <h1 className="fs1-5rem tas w100 lh1 c15 fw600 mb0-5rem">Company Description</h1>
                <p className="c3 fs14px w100 tas mb1rem">AI Generated</p>
                <div
                    className="df fdc fs14px c43 oya h40vh"
                    style={{
                        lineHeight: "1.8",
                        overflow: "scroll",
                        paddingRight: "14px",
                        backgroundPosition: "center",
                        backgroundRepeat: "no-repeat",
                        backgroundImage: `url(${require("../../../../images/aiWatermark.png")})`,
                    }}>
                    {company["companyDescription"]}
                </div>
                <p className="c4 fs11px fw500 w100 tas pt1rem mb0-5rem">You can later edit description in Company Settings</p>
                <div onClick={() => { dispatch(toggleModal({ open: "" })) }} className="df jcc fdc fdr-md aic fs1rem px2rem">
                    <Link className="cp bg4 c1 mt0-5rem br50px py0-75rem px2-5rem sm-px16px db fs14px sm-fs12px fw400 tac" to={ROUTES.LOGIN}>
                        Next
                    </Link>
                </div>
            </ModalWrapper>

            {/* Advisor type modal */}
            <Modal open={modal["open"] == "advisorType"} onClose={onAdvisorModalClose} className="backdrop td500 zi4 pf t0 l0 w100vw h100vh df jcc aic">
                <div className="mah90 oya bg1 p2rem shadow w30 bsbb df fdc maw600px br5px pr" style={{ outline: "none" }}>
                    <button className="close-popup" onClick={onAdvisorModalClose}>
                        <svg style={{ position: "relative", top: "4px" }} className="pen fds h1rem f1 mr0-5rem" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                            <path
                                className="pen fa-primary"
                                d="M310.6 361.4c12.5 12.5 12.5 32.75 0 45.25C304.4 412.9 296.2 416 288 416s-16.38-3.125-22.62-9.375L160 301.3L54.63 406.6C48.38 412.9 40.19 416 32 416S15.63 412.9 9.375 406.6c-12.5-12.5-12.5-32.75 0-45.25l105.4-105.4L9.375 150.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0L160 210.8l105.4-105.4c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25l-105.4 105.4L310.6 361.4z"
                            />
                        </svg>
                    </button>
                    <div className="df jcc fs1-5rem">Add Advisor type</div>
                    <input
                        type="text"
                        id="advisorType"
                        value={advisorTypeValue}
                        placeholder="Advisor Type"
                        style={{ paddingLeft: "50px" }}
                        onChange={(e) => setAdvisorTypeValue(e["target"]["value"])}
                        className="mt1rem pl1rem lpins w100 br10px p1rem custom-input"
                    />
                    <span className={`shadow bg3 c1 td250 br5px p0-5rem fw600 cp ttu bsbb tac mt1rem df jcc aic w50 `} style={{ backgroundColor: advisorTypeValue === "" && "lightgray", cursor: advisorTypeValue === "" ? "not-allowed" : "pointer" }}
                        onClick={() => { advisorTypeValue !== "" && onAdvisorTypeAdded() }}>
                        Add
                    </span>
                </div>
            </Modal>
        </>
    );
};

export default RegisterTwoMinuteTest;
